import { render, staticRenderFns } from "./ViewDetails.vue?vue&type=template&id=60a01b23&scoped=true&"
import script from "./ViewDetails.vue?vue&type=script&lang=js&"
export * from "./ViewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetails.vue?vue&type=style&index=0&id=60a01b23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a01b23",
  null
  
)

export default component.exports